import axios from 'axios'

import {
  type CreatorIntegrationsApi,
  CreatorIntegrationsApiClient,
} from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

const getPledgeShopCharityWithNull = async (
  params: CreatorIntegrationsApi.GetPledgeShopCharity.Params,
) => {
  try {
    return await CreatorIntegrationsApiClient.getPledgeShopCharity(params)
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // Return a mock AxiosResponse with null data for 404s
      return {
        data: null,
        status: 404,
        statusText: 'Not Found',
        headers: {},
        config: error.config || ({} as any),
      }
    }
    throw error
  }
}

export const usePledgeShopCharityQuery = createQueryHook(getPledgeShopCharityWithNull, {
  queryKey: ['pledgeShopCharity'],
  retry: false,
})
